module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jtk-demo-canvas canvas-wide flowchart-demo jtk-surface jtk-surface-nopan",
    style: ({
      position: 'relative',
      height: _vm.heightValue
    }),
    attrs: {
      "id": "canvas"
    }
  }, _vm._l((_vm.stages), function(eachStage, key, index) {
    return _c('div', {
      key: key,
      staticClass: "window jtk-node",
      style: (_vm.positionStage(eachStage, key, index)),
      attrs: {
        "id": key
      }
    }, [_vm._v(_vm._s(key) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.truncateText(eachStage.text[0].eng)) + " ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-04936ddf","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateSmsApp/preview.vue
// module id = dYvk
// module chunks = 1